var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60891 8.82648L10.2828 1.15261C10.9193 0.51604 11.9514 0.516041 12.588 1.15261L20.2619 8.82648C20.8984 9.46304 20.8984 10.4951 20.2619 11.1317L12.588 18.8056C11.9514 19.4421 10.9193 19.4421 10.2828 18.8056L2.60891 11.1317C1.97234 10.4951 1.97234 9.46304 2.60891 8.82648Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5351 13.4853C20.9113 13.1091 21.5422 13.1887 21.7705 13.6693C22.4753 15.1532 22.8711 16.8124 22.8711 18.5643C22.8709 24.8799 17.751 29.9999 11.4355 29.9999C5.1201 29.9999 0.000217491 24.8799 0 18.5643C0 16.8126 0.395212 15.1532 1.0997 13.6693C1.32789 13.1887 1.95882 13.1091 2.33504 13.4853L10.8592 22.0095C11.1775 22.3278 11.6936 22.3278 12.0119 22.0095L20.5351 13.4853Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedaIcon);
export default __webpack_public_path__ + "static/media/feeda-icon.bd8fe6565ddb7446453d1d9422696a1a.svg";
export { ForwardRef as ReactComponent };